export default {
  collegeProfile: "college profile",
  highSchoolProfile: "high school profile"
};
